import React from 'react'
import styled from '@emotion/styled'
import { Part__Hardwired_Switch } from 'components/SwitchAndGauge/parts-components'

/* eslint-disable react/jsx-pascal-case */
const Icon = (props) => <Part__Hardwired_Switch {...props} width={21} height={21} />

const HardwiredSwitchIcon = styled(Icon)`
  postion: relative;
  top: 0;
  right: 0;
`

export default HardwiredSwitchIcon
